import { Component, computed, ElementRef, HostListener, Inject, viewChild, ViewChild } from '@angular/core';
import { cAfdelingInfo, cAfdelingWM, cKopConfig } from '@wasm/KopWeb';
import { KopConfigService } from '../../core/kop-config.service';
import { JSBridgeService } from '../../core/jsbridge.service';
import { wasmVectorToArray } from '../../utils/wasmVector';
import { KopModulesService } from '../../modules/kop-modules.service';
import { AfdModule } from '@etron/typings';
import { CompoundValueType } from '../../props/module-props/module-props.component';
import { BreadCrumbItem } from '@progress/kendo-angular-navigation';

import {
  arrowRotateCcwIcon,
  homeIcon,
  SVGIcon,
} from "@progress/kendo-svg-icons";
import { Router } from '@angular/router';
import { DialogResult, DialogService } from '@progress/kendo-angular-dialog';
import { TitleDialogComponent } from '../title-dialog/title-dialog.component';
import { AutosaveService } from '../../core/autosave.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { ValidationService } from '../../modules/validation.service';
import { TranslateService } from '../../i18n/translate.service';
import { FocusManagerService } from '../../keynav/focus-manager.service';
import { getFlexLayout } from '../../utils/utils';

type BreadCrumbItemExtended = BreadCrumbItem & {
  key?: string;
}
@Component({
  selector: 'app-afdeling-list',
  templateUrl: './afdeling-list.component.html',
  styles: `
    .list-container {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      flex-grow: 0;
    }
    .module-container {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      flex-grow: 1;
      align-content: flex-start;
      background-color: lightgray;
    }
    .dropzone {
      background-color: green;
    }
    .clickable {
      cursor: pointer;
    }
    .new-container {
      display: flex;
    flex-direction: row;
    align-items: start;
    }
  `,
  providers: [
    {
      provide: 'i18n-label',
      useValue: 'AfdelingListComponent'
    }
  ]
})
export class AfdelingListComponent {



  constructor(public kopConfigService: KopConfigService, public jsBridgeService: JSBridgeService, public kopModulesService: KopModulesService,
    public router: Router, private dialogService: DialogService, private autoSaveService: AutosaveService, public validationService: ValidationService,
    private translateService: TranslateService, @Inject('i18n-label') private i18nLabel: any, private focusManager: FocusManagerService) { }

  public selectedAfd: string | undefined;

  public afdList = viewChild<ElementRef<HTMLDivElement>>('afdList');

  onCardClicked($event: cAfdelingWM, afdIdx: number) {
    //this.selectedAfd = $event.afdeling().uuid.toString();
    this.kopConfigService.selectedAfd.set($event);
    this.currentAfdIdx = afdIdx;
    let afdEl = this.afdList();
    if (afdEl != undefined) {
      afdEl.nativeElement.focus();
      this.focusManager.resetStack();
    }
  }

  onModuleClicked($event: AfdModule) {
    this.kopModulesService.selectedAfdModule.set($event);
  }

  public allAfd = computed(() => {
    let tmp = this.jsBridgeService.getBridgeSync().getAfdelingsInfo();
    let translateDB = this.translateService.kopDataDBSignal();
    if (translateDB == undefined) {
      return [];
    }
    let ret = wasmVectorToArray(tmp)
      .filter(a => a.valid4version && a.is_afdelin)
      .sort((a, b) => a.type - b.type)
      .map(a => {
        return {
          afd: a,
          text: this.translateService.translateKopDataSync(translateDB, 'afdtype', a.type, a.naam.toString()),
        }
      });
    tmp.delete();
    return ret;
  });

  public breadCrumb = computed(() => {
    let klantNo = this.jsBridgeService.getKlantNo();
    let version = this.jsBridgeService.version();
    let isDirty = this.autoSaveService.isDirty();
    let translateRepo = this.translateService.translateSignal();
    let ret: BreadCrumbItemExtended[] = [{
      text: this.translateService.getTranslationSync(translateRepo, this.i18nLabel, "Home", "Home"),
      title: this.translateService.getTranslationSync(translateRepo, this.i18nLabel, "Home", "Home"),
      key: "Home",
      svgIcon: homeIcon,
    }, {
      text: `${klantNo.toString()}(${version}) ${isDirty ? "*" : ""}`,
      title: this.translateService.getTranslationSync(translateRepo, this.i18nLabel, "klantNo", "klantNo"),
      key: "klantNo"
    }];
    let afd = this.kopConfigService.selectedAfd();
    if (afd != undefined) {
      let titel = afd.afdeling().titel.toString();
      ret.push({
        text: titel + " (" + (afd.afdeling().refNr - 1) + ")",
        title: titel
      })
    }
    let module = this.kopModulesService.selectedAfdModule();
    if (module != undefined) {
      let title = module.titel.toString();
      ret.push({
        text: title,
        title: title
      });
    }
    return ret;
  });

  onBreadCrumbClick(e: BreadCrumbItemExtended) {
    if (e.key == "klantNo") {
      this.kopConfigService.isDetail.set(false);
      this.kopModulesService.selectedAfdModule.set(undefined);
    } else if (e.key == "Home") {
      this.router.navigate(['/']);
    } else {
      this.kopModulesService.selectedAfdModule.set(undefined);
    }
  }

  onNew(e: any) {
    let selection = e.afd as cAfdelingInfo;
    const dialogRef = this.dialogService.open({
      width: 400,
      content: TitleDialogComponent,
    });

    const titleDlg = dialogRef.content.instance as TitleDialogComponent;
    titleDlg.maxLength = 8;
    let t = selection.naam.toString();
    t = t.replace("($)", "").trim();
    let translateRepo = this.translateService.translateSignal();
    let newT = this.translateService.getTranslationSync(translateRepo, this.i18nLabel, "Nieuw", "Nieuw");
    titleDlg.title = `${newT}`;  //${t}`;

    dialogRef.result.subscribe((r: any) => {
      console.log(r);

      if (r.text == "Submit") {
        this.kopConfigService.addAfd(selection, r.naam);
      }
    });
    // let afd = this.kopConfigService.addAfd(selection);

  }

  ngOnInit() {
  }

  public isDropValid = false;


  // public isEditingModule = false;
  public moduleKey: string | undefined;

  onModuleEditCancel() {
    this.kopModulesService.isEditingModule.set(false);
    this.moduleKey = undefined;
  }

  onDrop(e: CdkDragDrop<AfdModule[]>) {
    this.kopConfigService.moveAfd(e.previousIndex, e.currentIndex - 1);
  }

  onModuleEditApply(e: CompoundValueType) {
    console.log(e);
    let selectedAfd = this.kopConfigService.selectedAfd();
    for (let ld of e.losDefs) {
      this.kopConfigService.upsertLosDef(ld.losDef, 'losdef');
    }
    for (let ld of e.droogWands) {
      this.kopConfigService.upsertLosDef(ld.losDef, 'droogwand');
    }
    for (let ld of e.koelings) {
      this.kopConfigService.upsertLosDef(ld.losDef, 'koeling');
    }
    for (let ld of e.verwarmings) {
      this.kopConfigService.upsertLosDef(ld.losDef, 'verwarming');
    }

    for (let ai of e.ais) {
      this.kopConfigService.upsertAI(ai.ai);
    }
    for (let servo of e.servos) {
      this.kopConfigService.upsertServo(servo.servo, servo.meta);
    }
    for (let bp of e.bijzPrgms) {
      this.kopConfigService.upsertBijzPrgm(bp.bp, bp.meta);
    }
    for (let al of e.alarms) {
      this.kopConfigService.upsertAlarm(al.alarm);
    }
    if ((selectedAfd != undefined) && (this.moduleKey != undefined)) {
      this.kopModulesService.addModule(this.moduleKey, selectedAfd);
    }

    this.moduleKey = undefined;
    this.kopModulesService.isEditingModule.set(false);
  }

  onModuleDrop($event: DragEvent) {
    let key = $event.dataTransfer?.getData('module');
    this.moduleKey = key;
    this.kopModulesService.isEditingModule.set(true);
    // console.log($event, key);
    // let selectedAfd = this.kopConfigService.selectedAfd();
    // if ((selectedAfd != undefined) && (key != undefined)) {
    //   this.kopModulesService.addModule(key, selectedAfd);
    // }
    this.isDropValid = false;
  }

  onDragOver($event: DragEvent) {
    this.isDropValid = true;
    $event.preventDefault();
  }

  onDragEnd($event: DragEvent) {
    console.log("onDragEnd");
    this.isDropValid = false;
  }

  public currentAfdIdx = -1;

  @HostListener('document:keydown', ['$event'])
  onKeyDown(e: Event) {
    let afdEl = this.afdList();
    if (afdEl != undefined && this.focusManager.getFocusArea() == "base") {
      let keyEv = e as KeyboardEvent;
      let allAfdEl = this.kopConfigService.afdelings();
      let layout = getFlexLayout(afdEl.nativeElement);
      console.log("Layout", layout);
      let maxSize = allAfdEl.length;
      if ((keyEv.key == 'ArrowLeft') && (this.currentAfdIdx > 0)) {
        this.currentAfdIdx--;
      } else if ((keyEv.key == 'ArrowRight') && (this.currentAfdIdx < maxSize - 1)) {
        this.currentAfdIdx++;
      } else if (keyEv.key == 'ArrowDown' && (this.currentAfdIdx < maxSize - 1)) {
        let tmp = this.currentAfdIdx + layout.maxCol;
        if (tmp < maxSize) {
          this.currentAfdIdx = tmp;
        }
      } else if (keyEv.key == 'ArrowUp' && (this.currentAfdIdx > 0)) {
        let tmp = this.currentAfdIdx - layout.maxCol;
        if (tmp >= 0) {
          this.currentAfdIdx = tmp;
        }
      }
      let selectedAfd = allAfdEl[this.currentAfdIdx];
      this.kopConfigService.selectedAfd.set(selectedAfd);

    }
  }


}
